import { AuthConfig, SignInOptions } from '../types/types'
import cookieHandler from '../handlers/cookieHandler'

export default (config: AuthConfig, cookieHeader?: string) => {
  const cookies = cookieHandler(cookieHeader)

  const idToken = cookies.getIdToken()

  return (options: SignInOptions = {}): void => {
    let url = `${config.authServerUrl}/${options.provider}/signin?base_url=${location.origin}`

    if (options.returnUrl) {
      url = `${url}&return_url=${options.returnUrl}`
    }

    if (options.bounceUrl) {
      url = `${url}&bounce_url=${options.bounceUrl}`
    } else {
      const contactId = cookies.getContactId()
      const userIdentifier = cookies.getUserIdentifier()

      let params = ''

      if (userIdentifier) {
        params = `useridentifier=${userIdentifier}&`
      }

      if (contactId) {
        params = params + `contactid=${contactId}`
      }

      url = `${url}&bounce_url=${window.location.origin}/bounce/login?${params}`
    }

    if (options.language) {
      url = `${url}&language=${options.language}`
    }

    if (options.siteType) {
      url = `${url}&site_type=${options.siteType}`
    }

    if (options.username) {
      url = `${url}&username=${options.username}`
    }

    if (options.cancellationUrl) {
      url = `${url}&cancellation_url=${options.cancellationUrl}`
    }

    if (options.registrationUrl) {
      url = `${url}&registration_url=${options.registrationUrl}`
    }

    if (idToken) {
      url = `${url}&id_token=${idToken}`
    }

    cookies.clearTokens()

    location.href = url
  }
}
